<template>
  <ScreenWidthProvider v-slot="{ isNarrower, isWider }">
    <div
      v-if="isNarrower('md')"
      class="block md:hidden  mx-[calc(50%-170px)] mb-5"
    >
      <SlidesBehindSlider
        pagination
        class="clip-none"
        dots-align="outside"
        dots-type="blue"
        arrows-type="blue"
        loading-skeleton-animation="skeleton-slides"
        :loading-skeleton-aspect="false"
        loading-skeleton-height="400px"
        rewind
        backdrop-color="gray-50"
        :space-between="30"
        only-render-visible-slides
        prevent-swiper-update
        constant-display-navigation
        :dynamic-bullets="false"
        :coverflow-depth="0"
        :coverflow-stretch="50"
        effect="coverflow"
      >
        <TripCard
          v-for="(trip, index) in trips"
          :key="`t-${index}`"
          class="mb-5 mx-1"
          :trip="trip"
        />
      </SlidesBehindSlider>
    </div>
    <div
      v-else-if="isWider('md', 1)"
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-4"
    >
      <div
        v-for="trip in trips"
        :key="trip.id"
      >
        <TripCard
          :trip="trip"
        />
      </div>
    </div>
  </ScreenWidthProvider>
</template>

<script>
export default defineNuxtComponent({
  props: {
    short: {
      type: Boolean,
      default: false,
    },

    trips: {
      type: Array,
      default: () => [],
    },
  },
})
</script>
